import { render, staticRenderFns } from "./DashboardNumbers.vue?vue&type=template&id=619fccfc&scoped=true&"
import script from "./DashboardNumbers.vue?vue&type=script&lang=ts&"
export * from "./DashboardNumbers.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardNumbers.vue?vue&type=style&index=0&id=619fccfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619fccfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VProgressLinear,VRow})
